module.exports = require("live/components/events/ui/console-input");